import { render, staticRenderFns } from "./MoreThanOneConference.vue?vue&type=template&id=a08f4bb8&scoped=true&"
import script from "./MoreThanOneConference.vue?vue&type=script&lang=js&"
export * from "./MoreThanOneConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08f4bb8",
  null
  
)

export default component.exports